var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.78328 4.16668C5.78306 4.6087 5.60726 5.03254 5.29454 5.34494C4.98182 5.65735 4.55781 5.83273 4.11578 5.83251C3.67376 5.83229 3.24992 5.65648 2.93752 5.34377C2.62511 5.03105 2.44973 4.60704 2.44995 4.16501C2.45017 3.72298 2.62598 3.29915 2.9387 2.98674C3.25141 2.67434 3.67542 2.49896 4.11745 2.49918C4.55948 2.4994 4.98331 2.6752 5.29572 2.98792C5.60812 3.30064 5.78351 3.72465 5.78328 4.16668ZM5.83328 7.06668H2.49995V17.5H5.83328V7.06668ZM11.1 7.06668H7.78328V17.5H11.0666V12.025C11.0666 8.97501 15.0416 8.69168 15.0416 12.025V17.5H18.3333V10.8917C18.3333 5.75001 12.45 5.94168 11.0666 8.46668L11.1 7.06668Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.42bb4b9ed7babe38e38be3bc19ef0fe9.svg";
export { ForwardRef as ReactComponent };